import { RouteObject } from "react-router-dom";

export default [
  {
    index: true,
    lazy: () => import("./pages/landing"),
  },
  {
    path: "breakdown/:companyId",
    lazy: () => import("./pages/campaign-breakdown"),
  },
] as RouteObject[];
